import SEOLinkWindow from '@Components/Listings/SEOLinkWindow';

const DrilldownSearchView = (props) => {
    return (
        <>
        <h1 className='visually-hidden'>{props.PageHeader}</h1>
        <div className="drilldown-search-container centered-div-and-text">
            {props.InternalLinking && props.InternalLinking.InternalLinkGroups && props.InternalLinking.InternalLinkGroups.map(group =>
                <div key={group.ReactKey}>
                    <SEOLinkWindow InternalLinkGroup={group} InternalLinkColumns={group.InternalLinkColumns} IsSearchBySpecs={true} />
                </div>)}
            </div>
        </>
    );
};

export default DrilldownSearchView;
global.DrilldownSearchView = DrilldownSearchView;